module.exports = __webpack_public_path__ + "media/images/emblems/Coinsins-coat_of_arms-5d9affc678e7fd60bdf005750a8c851f.svg";